<div class="alert-modal">
  <div>
    <div class="image-container">
      <span class="close-icon" (click)="handleClose.emit()">
        <svg class="icon">
          <use xlink:href="/assets/img/svgs/svgset.svg#cross" />
        </svg>
      </span>
      <div class="phone-container">
        <svg class="zoom-circle">
          <use xlink:href="/assets/img/svgs/svgset.svg#zoom-circle" />
        </svg>
        <img src="/assets/img/alert-modal/phone1.png" [alt]="'vola-alert.alt' | transloco" class="phone" />
        <div class="spacer"></div>
        <img src="/assets/img/alert-modal/phone2.png" [alt]="'vola-alert.alt1' | transloco" class="phone phone2" />
      </div>
    </div>
    <div class="text-container">
      <span class="title zero-text default p-bigger-bold">{{ 'vola-alert.title' | transloco }} </span>
      <span class="text zero-text default p-small-reg">{{ 'vola-alert.text' | transloco }}</span>
    </div>
  </div>
</div>
